export { default } from './PrepeuMarato';
